import React, { createContext, useContext, useState, useRef, useCallback } from "react";
import "./Toast.css";

const ToastContext = createContext(null);

let _id = 0;

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const timers = useRef({});

  const remove = useCallback((id) => {
    setToasts((list) => list.filter((t) => t.id !== id));
    if (timers.current[id]) {
      clearTimeout(timers.current[id]);
      delete timers.current[id];
    }
  }, []);

  const push = useCallback(
    (type, message, ttl = 5000) => {
      const id = ++_id;
      setToasts((list) => [...list, { id, type, message }]);
      timers.current[id] = setTimeout(() => remove(id), ttl);
      return id;
    },
    [remove]
  );

  const api = useRef({
    success: (m, ttl) => push("success", m, ttl),
    error: (m, ttl) => push("error", m, ttl ?? 7000),
    info: (m, ttl) => push("info", m, ttl),
    dismiss: (id) => remove(id),
  });

  return (
    <ToastContext.Provider value={api.current}>
      {children}
      <div className="toast-stack" aria-live="polite">
        {toasts.map((t) => (
          <div key={t.id} className={`toast toast-${t.type}`} onClick={() => remove(t.id)}>
            <span className="toast-icon">
              {t.type === "success" ? "✓" : t.type === "error" ? "!" : "i"}
            </span>
            <span className="toast-msg">{t.message}</span>
            <span className="toast-close">×</span>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error("useToast must be used within ToastProvider");
  return ctx;
}
